import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { ICreateManualPayout } from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY, PAYOUTS_QUERY_KEY } from "../contsants";

export function useCreateManualPayout(campaignInfluencerId: string) {
  const {
    mutate: createManualPayout,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreateManualPayout>({
    mutationFn: async (payout) => {
      return await CampaignService.createManualPayout(payout).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      c.invalidateQueries({
        queryKey: [...PAYOUTS_QUERY_KEY()],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    createManualPayout,
    isCreating,
    isCreated,
  };
}
